import React from 'react';

const LoadingLogo = () => {
  return (
    <div className="loading">
      <svg
        width="50"
        height="50"
        viewBox="0 0 100 100"
        className="loading"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs id="SvgjsDefs2343" />
        <g id="SvgjsG2344" transform="matrix(1,0,0,1,0,0)" fill="#000000">
          <g id="g21">
            <path
              fill="#000000"
              d="M 24.666,2.5 H 5.334 C 3.769,2.5 2.5,3.769 2.5,5.334 v 19.331 c 0,1.565 1.269,2.834 2.834,2.834 h 19.331 c 1.565,0 2.834,-1.269 2.834,-2.834 V 5.334 C 27.5,3.769 26.231,2.5 24.666,2.5 Z"
              id="path3"
            />
            <path
              fill="#000000"
              d="M 59.704,2.5 H 40.373 c -1.565,0 -2.834,1.269 -2.834,2.834 v 19.331 c 0,1.565 1.269,2.834 2.834,2.834 h 19.331 c 1.565,0 2.835,-1.269 2.835,-2.834 V 5.334 C 62.539,3.769 61.27,2.5 59.704,2.5 Z"
              id="path5"
            />
            <path
              fill="#000000"
              d="m 94.742,2.5 h -19.33 c -1.566,0 -2.835,1.269 -2.835,2.834 v 19.331 c 0,1.565 1.269,2.834 2.835,2.834 h 19.33 c 1.566,0 2.836,-1.269 2.836,-2.834 V 5.334 C 97.578,3.769 96.309,2.5 94.742,2.5 Z"
              id="path7"
            />
            <path
              fill="#000000"
              d="M 24.666,37.667 H 5.334 c -1.565,0 -2.834,1.269 -2.834,2.834 v 19.331 c 0,1.565 1.269,2.834 2.834,2.834 h 19.331 c 1.565,0 2.834,-1.269 2.834,-2.834 V 40.501 C 27.5,38.936 26.231,37.667 24.666,37.667 Z"
              id="path9"
            />
            {/* 
              <path
                fill="#f9f9f9"
                d="M 59.704,37.667 H 40.373 c -1.565,0 -2.834,1.269 -2.834,2.834 v 19.331 c 0,1.565 1.269,2.834 2.834,2.834 h 19.331 c 1.565,0 2.835,-1.269 2.835,-2.834 V 40.501 c 0,-1.565 -1.269,-2.834 -2.835,-2.834 z"
                id="path11"
                className="always-visible"
              />
            */}
            <path
              fill="#000000"
              d="m 94.742,37.667 h -19.33 c -1.566,0 -2.835,1.269 -2.835,2.834 v 19.331 c 0,1.565 1.269,2.834 2.835,2.834 h 19.33 c 1.566,0 2.836,-1.269 2.836,-2.834 V 40.501 c 0,-1.565 -1.269,-2.834 -2.836,-2.834 z"
              id="path13"
            />
            <path
              fill="#000000"
              d="M 24.666,72.833 H 5.334 c -1.565,0 -2.834,1.269 -2.834,2.835 v 19.33 c 0,1.566 1.269,2.834 2.834,2.834 h 19.331 c 1.565,0 2.834,-1.268 2.834,-2.834 V 75.668 C 27.5,74.102 26.231,72.833 24.666,72.833 Z"
              id="path15"
            />
            <path
              fill="#000000"
              d="M 59.704,72.833 H 40.373 c -1.565,0 -2.834,1.269 -2.834,2.835 v 19.33 c 0,1.566 1.269,2.834 2.834,2.834 h 19.331 c 1.565,0 2.835,-1.268 2.835,-2.834 v -19.33 c 0,-1.566 -1.269,-2.835 -2.835,-2.835 z"
              id="path17"
            />
            <path
              fill="#000000"
              d="m 94.742,72.833 h -19.33 c -1.566,0 -2.835,1.269 -2.835,2.835 v 19.33 c 0,1.566 1.269,2.834 2.835,2.834 h 19.33 c 1.566,0 2.836,-1.268 2.836,-2.834 v -19.33 c 0,-1.566 -1.269,-2.835 -2.836,-2.835 z"
              id="path19"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default LoadingLogo;
